import { render, staticRenderFns } from "./index-details.vue?vue&type=template&id=6ecabbc8&scoped=true"
import script from "./index-details.vue?vue&type=script&lang=js"
export * from "./index-details.vue?vue&type=script&lang=js"
import style0 from "./index-details.vue?vue&type=style&index=0&id=6ecabbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecabbc8",
  null
  
)

export default component.exports